export default __webpack_public_path__ + "static/media/ExperienceWorkingGirls.32a35eec.png";